import { type FC } from 'react'

export const StatsSkeletonPage: FC = () => null
